module.exports = __webpack_public_path__ + "img/9788901220673.2a135779.jpg";